module.exports = __webpack_public_path__ + "static/media/rami.6d25271f.jpg";